import Drawer from "components/Drawer/index";
import InputPassword from "components/InputPassword/index";
import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";

import "./securityPasswordChange.scss";
// import PasswordPin from "components/PasswordPin/index";
import Button from "components/Button/index";

const SecurityPasswordChange = ({
  handleCancelModel,
  setVerifyPassword,
  handleSave,
  pinRequired = true,
  title = "Confirm Password Change",
  currentPassword,
  setCurrentPassword
}) => {
  const isMobile = useScreenMobile({ size: 992 });

  return isMobile ? (
    <Drawer
      heading={title}
      isVisible={true}
      handleCancel={handleCancelModel}
      showFooter={false}
    >
      <PasswordChange
        handleCancel={handleCancelModel}
        setVerifyPassword={setVerifyPassword}
        handleSave={handleSave}
        pinRequired={pinRequired}
        title={title}
        currentPassword={currentPassword}
        setCurrentPassword={setCurrentPassword}
      />
    </Drawer>
  ) : (
    <Modal
      heading={title}
      handleCancel={handleCancelModel}
      showFooter={false}
      customHeader={true}
      showCross={true}
      showHeader={false}
    >
      <PasswordChange
        handleCancel={handleCancelModel}
        setVerifyPassword={setVerifyPassword}
        handleSave={handleSave}
        pinRequired={pinRequired}
        title={title}
        currentPassword={currentPassword}
        setCurrentPassword={setCurrentPassword}
      />
    </Modal>
  );
};

export default SecurityPasswordChange;

// const PasswordChange = ({
//   handleCancel,
//   setVerifyPassword,
//   handleSave,
//   pinRequired,
//   title
// }) => {
//   const [currentPassword, setCurrentPassword] = useState({
//     password: "",
//     pin: ""
//   });

//   const otpValue = "123456";
//   const handleChangePassword = (e) => {
//     setCurrentPassword((prev) => ({
//       ...prev,
//       password: e.target.value
//     }));
//   };

//   const handleChangePin = (otp) => {
//     setCurrentPassword((prev) => ({
//       ...prev,
//       pin: otp
//     }));
//   };

//   const isButtonDisabled =
//     !currentPassword.password || (pinRequired && (currentPassword.pin?.length !== 6));

//   return (
//     <section className="container passwordChange">
//       <div className="passwordContent">
//         <p className="passwordLabel">Current Password</p>
//         <InputPassword
//           value={currentPassword.password}
//           onChange={handleChangePassword}
//         />
//         {pinRequired && (
//           <div style={{ paddingTop: "24px", width: "100%" }}>
//             <p className="passwordLabel">
//               Enter the six digit code from the authentication application
//             </p>
//             <PasswordPin
//               otp={currentPassword.pin}
//               setOtp={handleChangePin}
//               error={false}
//             />
//             {otpValue !== currentPassword.pin && <p className="passwordLabel errorPassword">
//               Please enter the valid code
//             </p>}
//           </div>
//         )}
//         <Button title="Verify" type="violet" onClick={handleSave} disabled={isButtonDisabled} />
//       </div>
//     </section>
//   );
// };

const PasswordChange = ({
  handleCancel,
  setVerifyPassword,
  handleSave,
  pinRequired,
  title,
  currentPassword,
  setCurrentPassword
}) => {
  // const [currentPassword, setCurrentPassword] = useState({
  //   password: "",
  //   pin: ""
  // });

  // const [pinError, setPinError] = useState(false); // State to handle pin validation error
  // const otpValue = "123456"; // Correct OTP value

  const handleChangePassword = (e) => {
    setCurrentPassword((prev) => ({
      ...prev,
      password: e.target.value
    }));
  };

  // const handleChangePin = (otp) => {
  //   setCurrentPassword((prev) => ({
  //     ...prev,
  //     pin: otp
  //   }));
  //   setPinError(false); // Reset error when user types new OTP
  // };
  const handleSubmit = () => {
    handleSave(); // Proceed with saving if PIN is correct
  };

  const isButtonDisabled =
    !currentPassword.password;
  //   //eslint-disable-next-line
  return (
    <section className="container passwordChange">
      <div className="passwordContent">
        <p className="passwordLabel">Current Password</p>
        <InputPassword
          value={currentPassword.password}
          onChange={handleChangePassword}
        />
        <Button
          title="Next"
          type="violet"
          onClick={handleSubmit} // Call handleSubmit instead of handleSave directly
          disabled={isButtonDisabled}
        />
      </div>
    </section>
  );
};
